import React from "react";
import { Grid, Paper, Card, CardContent, Typography, Box, useMediaQuery } from "@mui/material";
import person from "./assets/Images/person.png";

const AttendanceCard = ({ worker }) => {
  const workingHours = parseFloat(worker.workingHours || 0);
  const presentCount = worker.presentCount || 0;
  const totalWorkingHours = worker.leaveCount > 0 ? 0 : presentCount * workingHours;
  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 1,
        borderRadius: 2,
        boxShadow: 3,
        maxWidth: 700,
        mx: "auto",
        height: "70px",
        backgroundColor: "lightgrey",
      }}
    >
      <img
        src={worker.image || person} // Use worker image from backend, fallback to default
        alt="Worker"
        style={{ width: "60px", height: "60px", borderRadius: "30px" }}
      />
      <CardContent sx={{ flex: 1, px: 2, textAlign: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {worker.name || "Unknown Worker"}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          (Worker username: {worker.workerNumber || "N/A"})
        </Typography>
      </CardContent>
      <Box sx={{ textAlign: "right", pr: 2 }}>
        <Box
          sx={{
            display: "inline-block",
            bgcolor: "green",
            color: "white",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            fontSize: 12,
            fontWeight: "bold",
            mr: 1,
          }}
        >
          Present Count: {worker.presentCount || "0"}
        </Box>
        <Box
          sx={{
            display: "inline-block",
            bgcolor: "red",
            color: "white",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          Absent Count: {worker.leaveCount || "0"}
        </Box>
        <Box
          sx={{
            mt: 1,
            bgcolor: "orange",
            color: "black",
            fontFamily: "caladea",
            px: 2,
            textAlign: "center",
            py: 0.5,
            borderRadius: 1,
            fontWeight: "bold",
            fontSize: 14,
          }}
        >
          Total Working Hours: {(worker.presentCount || 0) * parseFloat(worker.workingHours || 0)} Hrs
        </Box>
      </Box>
    </Card>
  );
};
const AttendanceGrid = ({ workers = [], presentCount, absentCount }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTab = useMediaQuery("(max-width:1024px)");
  const isMobileOrTab = isMobile || isTab;
  return (
    <Paper
      sx={{
        height: "79vh",
        mt: 0.8,
        width: isMobileOrTab ? "750px" : "auto", // <-- Responsive width
        overflowY: "auto",
        overflowX: "hidden",
        position: "relative",
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 1000,
          width: isMobileOrTab ? "100%" : "auto", // <-- Responsive width
          py: 1,
          boxShadow: 2,
        }}
      >
        <Typography
          gutterBottom // Corrected the prop name
          sx={{
            width: "100%",
            fontFamily: "caladea",
            fontWeight: "bold",
            textAlign: "center",
            fontSize: 30,
          }}
        >
          TOTAL ATTENDANCE SUMMARY
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
          <Box sx={{ backgroundColor: "green", px: 3, py: 1, borderRadius: 2, color: "white", fontWeight: "bold" }}>
            Present: {presentCount}
          </Box>
          <Box sx={{ backgroundColor: "red", px: 3, py: 1, borderRadius: 2, color: "white", fontWeight: "bold" }}>
            Absent: {absentCount}
          </Box>
          <Box sx={{ backgroundColor: "orange", px: 3, py: 1, borderRadius: 2, color: "black", fontWeight: "bold" }}>
            Total Hours: 8 Hrs
          </Box>
        </Box>
      </Box>
      <Box sx={{ maxWidth: 800, mx: "auto", mt: 1 }}>
        <Grid container spacing={2}>
          {workers.length > 0 ? (
            workers.map((worker) => (
              <Grid item xs={12} key={worker.id}>
                <AttendanceCard worker={worker} />
              </Grid>
            ))
          ) : (
            <Typography textAlign="center" sx={{ width: "100%", mt: 2, fontWeight: "bold", color: "red" }}>
              No attendance records found.
            </Typography>
          )}
        </Grid>
      </Box>
    </Paper>
  );
};
export default AttendanceGrid;
